import React from "react";
import { DropOffIcon } from "../../../components/Icons";

interface IDoctorVisitToggleCard{
  handleToggle: () => void;

}

const DropOffToggleCard = ({ handleToggle }: IDoctorVisitToggleCard) => {
  const handleCardClick = () =>{
    handleToggle();
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-2">
        <div className="font-semibold text-sm">Would you rather book a Drop-Off?</div>
        <div className="text-gray-1 text-sm">
        Drop your pet off for care, and we’ll notify you when they’re ready for pick-up.
        </div>
      </div>
      <div
        onClick={()=> handleCardClick()}
        className="cursor-pointer border border-taupe-50 flex gap-3 bg-white
      rounded-lg p-3 items-center hover:bg-gv-yellow-light hover:gv-yellow">
        <div className="flex items-center justify-center bg-taupe-5 rounded-full p-2 h-fit">
          <DropOffIcon width={20} height={20} />
        </div>
        <div className="font-semibold text-sm">
            Book a Drop-Off Visit
        </div>
      </div>
    </div>
  );
};

export default DropOffToggleCard;
